// extracted by mini-css-extract-plugin
export default {"video":"LazyVideo_video__6+9FS","videoAlbum":"LazyVideo_videoAlbum__Ddkjp","videoControlsHidden":"LazyVideo_videoControlsHidden__2Yzz2","loader":"LazyVideo_loader__yF78i"};